import {
  BMButton,
  BMComponentsType,
  BMPopup,
  BMPrimitives,
  BMText,
  useBMTheme,
} from "@traveloka/district-bloom";
import { useMemo } from "react";
import { StyleSheet } from "react-native";
import BMView from "../../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../../core/resource/MobileResourceProvider";

type PriceChangeItem = {
  label: string;
  oldPrice?: string;
  newPrice: string;
};

type Props = {
  total?: string;
  items?: PriceChangeItem[];
  visible?: boolean;
  isLoading?: boolean;
  onClose?: () => void;
  onContinue?: () => void;
};

export default function PriceChangeModal({
  total = "",
  items = [],
  visible = true,
  isLoading = false,
  onClose = () => {},
  onContinue = () => {},
}: Props) {
  const { BMComponents } = useBMTheme();
  const styles = useMemo(() => createStyles(BMComponents), [BMComponents]);

  const { CorporateFlightPrebookForm: cr, CorporateCommon: cc } =
    useMobileContentResource();
  return (
    <BMPopup
      dismissible={false}
      isVisible={visible}
      onPopupClose={() => {}} // Disable default close on overlay press because dismissible is false
      title={cr.submitPriceChangeModalTitle}
    >
      <BMView spacing="lg">
        <BMText variant="paragraphNormal">
          {cr.submitPriceChangeModalDescription}
        </BMText>
        <BMView style={styles.wrapper}>
          <BMView style={[styles.paddingMd, styles.divider]} spacing="xs">
            {items.map((item, index) => (
              <BMView key={index} row justify="between" align="center">
                <BMText variant="paragraphSmall" ink="BMStyleTextInkSecondary">
                  {item.label}
                </BMText>
                <BMView spacing="xs" row align="center">
                  {item.oldPrice ? (
                    <BMText
                      variant="uiSmallLi"
                      style={styles.strikethrough}
                      ink="BMStyleTextInkSecondary"
                    >
                      {item.oldPrice}
                    </BMText>
                  ) : null}
                  <BMText variant="uiNormalLi">{item.newPrice}</BMText>
                </BMView>
              </BMView>
            ))}
          </BMView>
          <BMView style={styles.paddingMd} row justify="between" align="center">
            <BMText variant="paragraphSmall" ink="BMStyleTextInkSecondary">
              {cr.submitPriceChangeTotal}
            </BMText>
            <BMText ink="BMStyleTextInkPrice">{total}</BMText>
          </BMView>
        </BMView>
        <BMView row spacing="md">
          <BMView flex>
            <BMButton
              size="LARGE"
              role="SECONDARY"
              stretchable
              onPress={onClose}
              label={cc.declineText}
            />
          </BMView>
          <BMView flex>
            <BMButton
              size="LARGE"
              stretchable
              onPress={onContinue}
              loading={isLoading}
              label={cc.approveText}
            />
          </BMView>
        </BMView>
      </BMView>
    </BMPopup>
  );
}

function createStyles(BMComponents: BMComponentsType) {
  return StyleSheet.create({
    wrapper: {
      borderWidth: BMPrimitives.BMBorder.width.thick,
      borderRadius: BMPrimitives.BMBorder.radius.default,
      borderColor: BMComponents.BMStyleLineBordercolorSubtle,
      backgroundColor: BMComponents.BMStyleSurfaceBgcolorInventory,
    },
    divider: {
      borderBottomWidth: BMPrimitives.BMBorder.width.thick,
      borderColor: BMComponents.BMStyleLineBordercolorSubtle,
    },
    paddingMd: {
      padding: BMPrimitives.BMSize.md,
    },
    strikethrough: {
      textDecorationLine: "line-through",
    },
  });
}
